import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const items = ['6 Professional Volumes', '120 Ready-to-Customize AI Prompts', '4 Complementary Bonuses', 'Digital Access', 'Seven-Day Money-Back Guarantee, subject to the applicable terms'];
export function FinalCTA() {
  return <section aria-label="Get instant access" className="border-t border-line bg-ink-2" data-id="element-68" data-mp="83m5dk1n16u8">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center" style={{
      paddingTop: "23px",
      paddingBottom: "13px"
    }} data-id="element-69" data-mp="m3nibxv6g4q2">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-70" data-mp="h5ln6ekh8ey8">SIGMA SMART™ — 100+ AI Prompts for Private Security™</p>
        <h2 className="mt-3 font-display text-3xl font-bold uppercase leading-tight text-fog sm:text-5xl" data-id="element-71" data-mp="qvood21r4z7n">
          Make your daily documentation <span className="text-teal" data-id="element-72" data-mp="14whmrxv6ceg1">more structured</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-fog/75" data-id="element-73" data-mp="zwmt5mk0lara">
          You don't need another complicated system to learn from scratch. You need practical resources that help you approach
          recurring tasks with clear instructions, reusable structures, and a consistent review process.
        </p>

        <ul className="mx-auto mt-8 inline-flex flex-col gap-2.5 text-left" data-id="element-74" data-mp="2m21cmv0rsk1d">
          {items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-fog/85" data-id="element-75" data-mp="2r2p0x8xm6mrw">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-76" data-mp="2v4akfd4nlzb2" />
              {item}
            </li>)}
        </ul>

        <p className="mt-8 text-sm font-semibold text-fog/70" data-id="element-77" data-mp="30094ioiy8v5o">
          One-time payment: <span className="font-display text-2xl font-bold text-teal" data-id="element-78" data-mp="34u3ta6dew0bm">$27 USD</span>
        </p>
        <div className="mt-5 flex justify-center" data-id="element-79" data-mp="39rn8p9luij55">
          <CTAButton data-id="element-80" data-mp="3es1gqrng5t36">Get my Private Security AI Toolkit now</CTAButton>
        </div>
        <p className="mt-4 text-xs text-fog/55" data-id="element-81" data-mp="3istthuvj2g47">Secure checkout · Digital delivery · Seven-day money-back guarantee</p>
      </div>
    </section>;
}